/**
 * `?trace` dev hook: the P2P state checksum at the end of every turn, for
 * comparing a replay played before and after a refactor (BUILDLIST Phase 51).
 *
 * Open the game with `?trace`, play a saved replay to the end, then in the
 * browser console: `copy(__orbituaryTrace.join('\n'))` and diff the two runs.
 * Each line: `t<turnNumber> p<currentPlayerIndex> <checksum hex>`.
 */
import type { GameState } from '../types';
import { computeStateChecksum } from '../network/protocol';

const enabled = typeof location !== 'undefined' && new URLSearchParams(location.search).has('trace');
const lines: string[] = [];
if (enabled) (globalThis as unknown as { __orbituaryTrace: string[] }).__orbituaryTrace = lines;

export function traceTurnChecksum(state: GameState): void {
  if (!enabled) return;
  const line = `t${state.turnNumber} p${state.currentPlayerIndex} ${(computeStateChecksum(state) >>> 0).toString(16).padStart(8, '0')}`;
  lines.push(line);
  console.log(`[trace] ${line}`);
}

/** A new match (or replay) starts a fresh trace. */
export function resetChecksumTrace(): void {
  lines.length = 0;
}
